module.exports = __webpack_public_path__ + "static/img/512_new.c51d8b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/512_new.png
// module id = 7BxL
// module chunks = 0